export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  allowedRoles?: string[] // Add role-based filtering
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'mso-dashboard',
      },
      allowedRoles: ['admin'],
    },
    {
      name: 'members',
      displayName: 'menu.members',
      meta: {
        icon: 'mso-group',
      },
      allowedRoles: ['admin'],
    },
    {
      name: 'profile',
      displayName: 'menu.myProfile',
      meta: {
        icon: 'mso-account_circle',
      },
      allowedRoles: ['user'],
    },
  ] as INavigationRoute[],
  bottomRoutes: [
    {
      name: 'profile',
      displayName: 'menu.profile',
      meta: {
        icon: 'mso-account_circle',
      },
      allowedRoles: ['admin', 'user'],
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'mso-settings',
      },
      allowedRoles: ['admin', 'user'],
    },
  ] as INavigationRoute[],
}
